import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {UniversalSearchResultModel} from '../models/universal-search-result.model';

@Injectable({
  providedIn: 'root',
})
export class SearchService {

  api = environment.api;
  workspaceId: string;

  constructor(private http: HttpClient) { }

  search(searchKey: string): Observable<any> {
    const body = {
      searchKey,
      workspaceId: this.workspaceId,
    };
    return this.http.post(`${this.api}/SearchData/Search`, body);
  }

  setWorkspaceId(workspaceId: string): void{
    this.workspaceId = workspaceId;
  }
}
